import './App.css';
import Header from './components/header';

function App() {
  return (
        <Header />
  );
}

export default App;
